import React from "react";
import { Outlet } from "react-router-dom";
import { localStorageUtil } from "../utils/CommonFunctions";
import { logout } from "../utils/tokenManager";

const REQUIRED_KEYS = ["authToken", "userData"];

const ProtectedRouteWrapper = () => {
  const keysPresent = REQUIRED_KEYS.every((key) => localStorage.getItem(key));
  const userData = keysPresent ? localStorageUtil.getItem("userData") : null;
  const isAuthenticated = keysPresent && userData?.role_name;

  if (!isAuthenticated) {
    logout();
    return null;
  }

  return <Outlet />;
};

export default ProtectedRouteWrapper;
